import axios from 'axios';

export const toggleScreenHostActive = (token, userId, hostNewStatus) => {
    return axios.get(process.env.REACT_APP_API_URL + '/admin/toggleScreenHostActive', {
        headers: { Authorization: token },
        params: { userId, hostNewStatus }
    });
};
